import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiPersuasive: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_16895)">
                <path
                    d="M10.2426 1.75738C9.10939 0.624123 7.60266 0 6 0C4.39734 0 2.89061 0.624123 1.75736 1.75738C0.6241 2.89061 0 4.39734 0 6C0 7.60266 0.624099 9.10939 1.75738 10.2426C2.89064 11.3759 4.39736 12 6.00002 12C7.60268 12 9.10941 11.3759 10.2427 10.2426C11.3759 9.10939 12 7.60266 12 6C12 4.39734 11.3759 2.89061 10.2426 1.75738ZM9.74542 9.74542C8.74499 10.7459 7.41482 11.2968 6 11.2968C4.58515 11.2968 3.25501 10.7458 2.25456 9.74542C1.25413 8.74501 0.703158 7.41485 0.703158 6C0.703158 4.58515 1.25413 3.25501 2.25456 2.25456C3.25499 1.25411 4.58515 0.703158 6 0.703158C7.41482 0.703158 8.74499 1.25413 9.74542 2.25456C10.7459 3.25501 11.2968 4.58518 11.2968 6C11.2968 7.41482 10.7459 8.74501 9.74542 9.74542Z"
                    fill="#FF6644"
                />
                <path
                    d="M5.08945 5.62894C5.08945 5.24766 4.77929 4.9375 4.39801 4.9375H2.44434V5.64066H3.70686C3.71316 6.01652 4.02065 6.32038 4.39799 6.32038C4.77929 6.32038 5.08945 6.01021 5.08945 5.62894Z"
                    fill="#FF6644"
                />
                <path
                    d="M8.87553 4.9375H6.92188V5.64066H8.18437C8.19068 6.01652 8.49817 6.32038 8.87551 6.32038C9.25678 6.32038 9.56694 6.01021 9.56694 5.62894C9.56694 5.24766 9.25681 4.9375 8.87553 4.9375Z"
                    fill="#FF6644"
                />
                <path
                    d="M6.38057 8.54289H4.61719V9.24605H6.38057C7.12741 9.24605 7.73504 8.63845 7.73504 7.8916H7.03188C7.03188 8.25073 6.73969 8.54289 6.38057 8.54289Z"
                    fill="#FF6644"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_16895">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiPersuasive;
